import { render, staticRenderFns } from "./reportDataBase.vue?vue&type=template&id=a8ca078a&scoped=true&"
import script from "./reportDataBase.vue?vue&type=script&lang=js&"
export * from "./reportDataBase.vue?vue&type=script&lang=js&"
import style0 from "./reportDataBase.vue?vue&type=style&index=0&id=a8ca078a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ca078a",
  null
  
)

export default component.exports